module.exports = __webpack_public_path__ + "static/media/Mayo.65e680d0.png";